import { MenuItem } from './common/fec/fec-menu/menu-item';
import { Feature } from './core/access';

const popUpMapping = new Map<string, Feature>([
  ['open-ssc', Feature.salesAndSuccessCenterAccess],
  ['open-meetings', Feature.salesAndSuccessCenterAccess],
  ['open-task-manager', Feature.concierge],
]);

export function popUpShouldRedirectToCTA(item: MenuItem): boolean {
  return item.locked && popUpMapping.has(item.menuId);
}

function getFeatureForPopUp(key: string): Feature {
  return popUpMapping.get(key);
}

export function getCallToActionUrl(item: MenuItem): string {
  const feature = getFeatureForPopUp(item.menuId);
  return `/restricted/${feature}`;
}
